class AddonsWrapper extends HTMLElement {
  constructor() {
    super();

    const storageAddons = localStorage.getItem('preselected-addons');
    window._SELECTED_ADDONS = storageAddons ? JSON.parse(storageAddons) : [];
  }

  connectedCallback () {
    this.optionalAddons = null; // output addons collection

    this.preselectAddon = this.preselectAddon.bind(this);
    this.unselectAddon = this.unselectAddon.bind(this);
    this.updateAddonStates = this.updateAddonStates.bind(this);
    this.updateStorage = this.updateStorage.bind(this);
    this.addAddonsToCart = this.addAddonsToCart.bind(this);
    this.addLoadingStates = this.addLoadingStates.bind(this);
    this.removeLoadingStates = this.removeLoadingStates.bind(this);
    this.unselectAllAddons = this.unselectAllAddons.bind(this);

    this.addonsPopup = document.querySelector('add-ons-popup');

    this.updateAddonStates();
  }

  get onPageAddons () {
    return document.querySelectorAll('addon-product');
  }

  preselectAddon ({ product, variant }) {
    const matchingAddon = window._SELECTED_ADDONS.find(addon => addon.product === product && addon.variant === variant);
    if (!matchingAddon) {
      window._SELECTED_ADDONS.push({ product, variant });
    }
    console.log('selected addon', window._SELECTED_ADDONS);
    this.updateAddonStates(window._SELECTED_ADDONS);
    this.updateStorage(window._SELECTED_ADDONS);
  }

  unselectAddon ({ product, variant }) {
    const newAddons = window._SELECTED_ADDONS.filter(addon => addon.product !== product && addon.variant !== variant);;
    window._SELECTED_ADDONS = newAddons
    this.updateAddonStates(newAddons);
    this.updateStorage(newAddons);
  }

  updateAddonStates (addons = window._SELECTED_ADDONS) {
    this.onPageAddons.forEach(pageAddon => {
      pageAddon?.updateState && pageAddon.updateState(addons);
    });

    this.addonsPopup?.updateLiveRegions && this.addonsPopup.updateLiveRegions(addons);
  }

  updateStorage (addons = window._SELECTED_ADDONS) {
    localStorage.setItem('preselected-addons', JSON.stringify(addons));
  }

  async addAddonsToCart (products, selling_plan) {
    console.log('products', products);
    console.log('window._SELECTED_ADDONS', window._SELECTED_ADDONS);
    console.log('selling plan', selling_plan);

    if (!products || !products.length) {
      products = window._SELECTED_ADDONS;
    }

    const config = fetchConfig('javascript');

    // find original selling plan
    try {
      const full_selling_plan = window.main_product_selling_plans.find(o => {
        return o.selling_plans.find(sp => sp.id === Number(selling_plan))
      });

      for (let product of products) {
        const matching_selling_plan = window.addon_product_selling_plans[product.product].find(sp => sp.name === full_selling_plan.name)
        product.selling_plan = matching_selling_plan.selling_plans[0].id;
      }
    } catch (e) {
      console.error(e);
    }

    this.addLoadingStates();

    config.body = JSON.stringify({
      items: products.map(p => {
        return {
          id: p.variant,
          quantity: 1,
          selling_plan: p.selling_plan
        }
      })
    });

    await fetch(routes.cart_add_url, config)
      .then(response => response.json())
      .then(cartItem => {
        console.log('Product added to cart:', cartItem);
      })
      .catch(error => {
        console.error('Error adding product to cart:', error);
      });

    this.removeLoadingStates();
  }

  addLoadingStates () {
    this.onPageAddons.forEach(pageAddon => {
      if (pageAddon.selected) {
        pageAddon.setLoading(true);
      }
    });
  }

  removeLoadingStates () {
    this.onPageAddons.forEach(pageAddon => {
      if (pageAddon.isLoading) {
        pageAddon.setLoading(false);
      }
    });
  }

  unselectAllAddons () {
    window._SELECTED_ADDONS = [];
    this.updateStorage([]);
    this.updateAddonStates([]);
  }
}

class AddonProduct extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.selected = false;
    this.product = this.dataset.product;
    this.variant = this.dataset.variant;
    this.button = this.querySelector('.button');

    this.addonsWrapper = document.querySelector('add-ons');

    this.onButtonClick = this.onButtonClick.bind(this);
    this.select = this.select.bind(this);
    this.unselect = this.unselect.bind(this);
    this.updateState = this.updateState.bind(this);
    this.setLoading = this.setLoading.bind(this);

    this.updateState();

    this.button.addEventListener('click', this.onButtonClick, false);
  }

  updateState (addons = window._SELECTED_ADDONS) {
    const matchingAddon = addons?.find(addon => addon.product === this.product && addon.variant === this.variant);
    if (matchingAddon && !this.selected) {
      this.select(true);
    } else if (!matchingAddon && this.selected) {
      this.unselect(true);
    }
  }

  onButtonClick () {
    if (this.closest('cart-drawer')) {
      this.setLoading(true);
      this.addonsWrapper.addAddonsToCart([{
        product: this.product,
        variant: this.variant,
      }])
        .then(() => {
          this.setLoading(false);
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: this.variant,
            cartData: null,
          })
        });

      return;
    }

    if (this.selected) {
      this.unselect();
    } else {
      this.select();
    }
  }

  select (onlyState = false) {
    this.button.querySelector('span').innerText = 'Selected';
    this.selected = true;

    if (onlyState) return;

    this.addonsWrapper.preselectAddon({
      product: this.product,
      variant: this.variant,
    })
  }

  unselect (onlyState = false) {
    this.button.querySelector('span').innerText = 'Add';
    this.selected = false;

    if (onlyState) return;

    this.addonsWrapper.unselectAddon({
      product: this.product,
      variant: this.variant,
    });
  }

  setLoading (isLoading) {
    if (isLoading) {
      this.isLoading = true;
      this.querySelector('span').classList.add('hidden');
      this.querySelector('.loading__spinner').classList.remove('hidden');
    } else {
      this.isLoading = false;
      this.querySelector('span').classList.remove('hidden');
      this.querySelector('.loading__spinner').classList.add('hidden');
    }
  }
}

class AddonsPopup extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addonsWrapper = document.querySelector('add-ons');

    this.updateLiveRegions = this.updateLiveRegions.bind(this);
    this.updateSelectedMessage = this.updateSelectedMessage.bind(this);
    this.updateCount = this.updateCount.bind(this);
    this.updateButtons = this.updateButtons.bind(this);
    this.updateAddonPrices = this.updateAddonPrices.bind(this);
    this.updateAddonBrands = this.updateAddonBrands.bind(this);

    this.updateSelectedMessage();
    this.updateCount();
    this.updateButtons();
    this.updateAddonBrands();

    this.slider = new Glide(this.querySelector('.glide'), {
      type: 'slider',
      startAt: 0,
      perView: 2,
      focusAt: 0,
      gap: 16,
      peek: {
        before: 22,
        after: 100
      },
      breakpoints: {
        749: {
          perView: 1,
          peek: {
            before: 10,
            after: 30
          },
          gap: 8,
          focusAt: 0,
        }
      }
    }).mount();

    this.slider.on('run.after', this.updateActiveBullet.bind(this));

    this.updateActiveBullet();
  }

  updateAddonBrands (has_selling_plan) {
    let selector = '.addon-header .addon-brand';
    if (!has_selling_plan) {
      selector = '.selling_plan_info';
    }

    this.querySelectorAll('.addon-slide')
      .forEach((item) => {
        if (item.dataset.brandImage) {
          console.log(item.dataset.brandImage);
          item.querySelector(selector).innerHTML = `
            <img src="${item.dataset.brandImage}" width="200" alt="" loading="lazy" style="max-width: 100px;" />
          `;
        }
      });
  }

  updateActiveBullet () {
    this.querySelectorAll('.glide__bullet')
      .forEach(el => {
        if (el.dataset.glideDir === `=${this.slider.index}`) {
          el.classList.add('glide__bullet--active');
        } else {
          el.classList.remove('glide__bullet--active');
        }
      })
  }

  updateLiveRegions (addons = window._SELECTED_ADDONS) {
    this.updateSelectedMessage(addons);
    this.updateCount(addons);
    this.updateButtons(addons);
  }

  updateSelectedMessage (addons = window._SELECTED_ADDONS) {
    const selectedEl = this.querySelector('#selected-addons');
    if (addons.length > 0) {
      selectedEl.innerHTML = `${addons.length} selected`;
    } else {
      selectedEl.innerHTML = null;
    }
  }

  updateCount (addons = window._SELECTED_ADDONS) {
    const selectedEl = this.querySelector('#addons-count');
    selectedEl.innerText = `${addons.length} extra${addons.length > 1 ? 's' : ''}`;
  }

  updateButtons (addons = window._SELECTED_ADDONS) {
    const continueWith = this.querySelector('.continue-with');
    const continueWithout = this.querySelector('.continue-without.button');
    const viewCart = this.querySelector('.continue-without.link--text');

    if (addons.length > 0) {
      viewCart.classList.add('hidden');
      continueWith.classList.remove('hidden');
      continueWithout.classList.add('button--tertiary');
      continueWithout.classList.remove('button--primary');
    } else {
      viewCart.classList.remove('hidden');
      continueWith.classList.add('hidden');
      continueWithout.classList.remove('button--tertiary');
      continueWithout.classList.add('button--primary');
    }
  }

  updateAddonPrices (selling_plan) {
    if (!selling_plan) {
      this.updateAddonBrands(null);
      this.querySelectorAll('.addon-slide')
        .forEach((item) => {
          const price = item.querySelector('.price');
          price.innerHTML = `+ £${(price.dataset.price / 100).toFixed(2)}`;
        });
      return;
    }

    const full_selling_plan = window.main_product_selling_plans.find(o => {
      return o.selling_plans.find(sp => sp.id === Number(selling_plan))
    });

    this.querySelectorAll('.addon-slide')
      .forEach((item) => {
        const matching_selling_plan = window.addon_product_selling_plans[item.dataset.product].find(sp => sp.name === full_selling_plan.name);
        if (matching_selling_plan) {
          const price_adjustment = matching_selling_plan.selling_plans[0]?.price_adjustments[0];
          if (price_adjustment && price_adjustment.value !== 0) {
            const price = item.querySelector('.price');
            if (price_adjustment.value_type === 'percentage') {
              const discount_amt = price.dataset.price * 0.1;
              const new_total = price.dataset.price - discount_amt;
              price.innerHTML = `+ £${(new_total / 100).toFixed(2)} <s>£${(price.dataset.price / 100).toFixed(2)}</s>`;
            } else {
              price.innerHTML = `+ £${((matching_selling_plan.selling_plans[0].price_adjustments[0].value) / 100).toFixed(2)}`;
            }

          }

          item.querySelector('.selling_plan_info').innerHTML = `(Included in each delivery)`
        }
      });

    this.updateAddonBrands(true);
  }
}

customElements.define('addon-product', AddonProduct);
customElements.define('add-ons', AddonsWrapper);
customElements.define('add-ons-popup', AddonsPopup);
